import { ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'app-grouping-column-selector',
  templateUrl: './grouping-column-selector.component.html',
  styleUrls: ['./grouping-column-selector.component.scss']
})
export class GroupingColumnSelectorComponent {

  @Input()
  selectedGroupingColumn?: string;

  availableColumns: { name: string; title: string }[] = [];

  constructor(private changeDetector: ChangeDetectorRef) { }

  setAvailableColumns(cols: { name: string; title: string }[]): void {
    this.availableColumns = cols;
    this.changeDetector.detectChanges();
  }

  onVisibilityChanged(newVisibleColumns: { name: string; title: string }[]): void {
    if (!newVisibleColumns.some(c => c.name === this.selectedGroupingColumn))
      this.selectedGroupingColumn = null;
    this.availableColumns = newVisibleColumns;
  }
}
